// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3m1YG","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__289yz"};